

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ModalShowReceipt',
  mounted () {
    console.log('mounted')
  },
  computed: {
    ...mapGetters(['currentOrder']),
    receipt () {
      return this.currentOrder && this.currentOrder.receipt ? atob(this.currentOrder.receipt).replace(/â\x80/g, '').replace(/¢/g, '&bull;') : null
    }
  },
  methods: {
    ...mapMutations(['setCurrentOrder'])
  }
}
